export default __webpack_public_path__ + "static/media/lights.3f741bf6.svg";